/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Sortbycompleted3Inputs */

const id_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutkan berdasarkan % Selesai`)
};

const ms_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun mengikut % Siap`)
};

const da_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter efter Fuldført %`)
};

const de_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Abschluss % sortieren`)
};

const en_us2_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by Completed %`)
};

const es_es2_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por % completado`)
};

const es_mx2_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por % completado`)
};

const fil_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbukud-bukurin ayon sa % ng Natapos`)
};

const fr_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier par % de complétion`)
};

const it_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina per % completamento`)
};

const hu_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendezés teljesítési % szerint`)
};

const nl_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteren op voltooiings %`)
};

const no_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter etter fullført %`)
};

const pl_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortuj według % ukończenia`)
};

const pt_br2_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificar por % concluída`)
};

const pt_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por % concluído`)
};

const ro_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortează după % finalizat`)
};

const fi_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järjestä suoritusprosentin mukaan`)
};

const sv_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortera efter slutförande %`)
};

const vi_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp theo % hoàn thành`)
};

const tr_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamamlanma %'sine Göre Sırala`)
};

const cs_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seřadit podle % dokončení`)
};

const bg_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортиране по % завършени`)
};

const ru_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировка по % выполнения`)
};

const uk_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортувати за % виконання`)
};

const ar_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتيب حسب نسبة الإنجاز`)
};

const hi_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण % के अनुसार क्रमबद्ध करें`)
};

const th_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียงตาม % ที่สำเร็จ`)
};

const ja_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`達成率順`)
};

const zh_cn2_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按完成百分比排序`)
};

const zh_hant1_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按完成百分比排序`)
};

const ko_offerdetail_achievements_sortbycompleted3 = /** @type {(inputs: Offerdetail_Achievements_Sortbycompleted3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완료율별 정렬`)
};

/**
* | output |
* | --- |
* | "Sort by Completed %" |
*
* @param {Offerdetail_Achievements_Sortbycompleted3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_sortbycompleted3 = /** @type {((inputs?: Offerdetail_Achievements_Sortbycompleted3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Sortbycompleted3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "da") return da_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "de") return de_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "it") return it_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "no") return no_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "th") return th_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_sortbycompleted3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_sortbycompleted3(inputs)
	return ko_offerdetail_achievements_sortbycompleted3(inputs)
});
export { offerdetail_achievements_sortbycompleted3 as "offerDetail.achievements.sortByCompleted" }